import React from 'react';
import ContactInfo from './contact/ContactInfo';
import ContactMap from './contact/ContactMap';
import ContactForm from './contact/ContactForm';
import {Helmet} from "react-helmet";
import {Animated} from "react-animated-css";

const Contact = () => (
  <Animated animationIn="fadeIn">
    <Helmet>
      <title>ติดต่อเรา - GongIdeas | Let's imagine come true.</title>
    </Helmet>
    <div className="container-fluid">
      <h1 className="text-center">ติดต่อเรา</h1>
      <div className="row">
        <Animated animationIn="fadeInLeft" animationInDelay="300" className="col-md-6 col-lg-5">
          <ContactInfo />
        </Animated>
        <Animated animationIn="fadeInRight" animationInDelay="600" className="col-md-6 col-lg-7">
          <ContactForm />
        </Animated>
      </div>
    </div>
    <Animated animationIn="fadeIn" animationInDelay="900">
      <ContactMap />
    </Animated>
  </Animated>
);

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js